import styled from '@emotion/styled';
import Chip from '@mui/material/Chip';
import { colors } from 'constants/colors';

export const StyledChip = styled(Chip)({
  position: 'absolute',
  left: 0,
  top: 0,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: 0,

  '& .MuiChip-label': {
    fontFamily: 'Modak',
    color: colors.default.info,
    WebkitTextStroke: '1px #272727',
    fontSize: '18px',
    textTransform: 'uppercase',
  },
});
